import { render } from "./MenuEntries.vue?vue&type=template&id=370bcb17"
import script from "./MenuEntries.vue?vue&type=script&lang=js"
export * from "./MenuEntries.vue?vue&type=script&lang=js"

import "./MenuEntries.vue?vue&type=style&index=0&id=370bcb17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__